export const GET_BULK_UPLOADS = `
  query BulkUploadSearch($page: ID!, $numberPerPage: ID, $fileType: String, $source: String, $state: String, $userId: String) {
    bulkUploadSearch(page: $page, numberPerPage:$numberPerPage, fileType: $fileType, source: $source, state: $state, userId: $userId) {
      count
      errors{
        description
        property
      }
      results{
        id
        createdAt
        fileType
        state
        url
        source
        errorFileUrl
        user{
          name
          id
        }
      }
    }
  }
`;

export const GET_BULK_UPLOAD_FILE_OPTIONS = `
  query {
    fileOptionsForBulkUpload{
      key
      value
    }
  }
`;
